import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchInspectionKindRevision(id, revisionNo) {
  const { data: raw } = await request.get(
    `/ims/inspection-kinds/${id}/revisions/${revisionNo}`,
  );
  return parseVer4DetailResponse(raw);
}
